"use client"
import { selectedAccessoriesSelector } from "components/shopFeatures/accessories/accessoriesSelectors"
import { selectedColorSelector } from "components/shopFeatures/color/colorSelectors"
import { selectedDetailingSelector } from "components/shopFeatures/detailing/detailingSelectors"
import { selectedUpholsterySelector } from "components/shopFeatures/upholstery/upholsterySelectors"
import { Font } from "components/shopFeatures/wizard/constants"
import OutOfStockBanner from "components/shopFeatures/wizard/OutOfStockBanner"
import { useTypedSelector } from "store"
import styled from "styled-components"
import PriceDetail from "./PriceDetail"

const StyledDivider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${(p) => p.theme.colors.lightGray};
  margin: ${(p) => p.theme.spacing(2, 0, 4)};
`

const StyledPriceContainer = styled.div`
  ${(p) => p.theme.breakpoints.up("md")} {
    min-width: 390px;
  }
`

const StyledHeading = styled.h3`
  font-family: ${Font.OENaPro};
  font-size: 20px;
  font-weight: 400;
  line-height: 1.6;
  letter-spacing: 0em;
  margin: 0;
  border-bottom: 1px solid ${(p) => p.theme.colors.lightGray};
  padding-bottom: 10px;
  margin-bottom: 10px;
`

const StyledContentContainer = styled.div`
  padding: 10px;
  background: ${(p) => p?.theme?.colors?.white};
`

const PriceDetails = () => {
  const isPreSale = useTypedSelector(
    (state) => state.wizard.model?.typeId === 3
  )
  const detailing = useTypedSelector(selectedDetailingSelector)
  const color = useTypedSelector(selectedColorSelector)
  const upholstery = useTypedSelector(selectedUpholsterySelector)
  const accessories = useTypedSelector(selectedAccessoriesSelector)
  const { authenticated } = useTypedSelector((state) => state.auth)
  const { licensingFee, price, advancePaymentAmount } = useTypedSelector(
    (state) => state.wizard
  )

  const totalAccessoryDiscount = accessories.reduce(
    (sum, acc) => sum + acc.price.discount,
    0
  )
  const totalColorDiscount = color?.price?.discount || 0
  const totalUpholsteryDiscount = upholstery?.price?.discount || 0
  const onlineDiscount = detailing?.price?.discount || 0

  const hasDiscount =
    authenticated &&
    (totalAccessoryDiscount > 0 ||
      totalColorDiscount > 0 ||
      totalUpholsteryDiscount > 0 ||
      onlineDiscount > 0)

  return (
    <StyledPriceContainer>
      <StyledContentContainer>
        <StyledHeading>סיכום הזמנה</StyledHeading>
        <OutOfStockBanner isSummery />
        {detailing && (
          <>
            <PriceDetail
              label="מחיר מחירון"
              price={detailing.price.originalPrice}
            />
            <PriceDetail
              label={detailing.details.name}
              price={detailing.price}
              title="רמת גימור"
            />
          </>
        )}
        {color && (
          <PriceDetail
            title="צבע"
            label={color.details.name}
            price={color.price}
          />
        )}
        {upholstery && (
          <PriceDetail
            title="ריפוד"
            label={upholstery.details.name}
            price={upholstery.price}
          />
        )}
        {accessories.map((accessory) => (
          <PriceDetail
            key={accessory.details.code}
            label={accessory.details.name}
            price={accessory.price}
            title="אבזור"
          />
        ))}
        {licensingFee?.totalPrice && (
          <PriceDetail label="אגרת רישוי" price={licensingFee.totalPrice} />
        )}

        {hasDiscount && (
          <>
            <StyledDivider />

            {totalColorDiscount > 0 && (
              <PriceDetail label="הנחת צבע" price={-totalColorDiscount} />
            )}
            {totalUpholsteryDiscount > 0 && (
              <PriceDetail
                label="הנחת ריפוד"
                price={-totalUpholsteryDiscount}
              />
            )}

            {totalAccessoryDiscount > 0 && (
              <PriceDetail label="הנחת אביזר" price={-totalAccessoryDiscount} />
            )}
            {onlineDiscount > 0 && (
              <PriceDetail
                label={
                  isPreSale ? "הטבת השקה מיוחדת" : "הנחה בגין רכישה אונליין"
                }
                price={-onlineDiscount}
              />
            )}
          </>
        )}
        {(price?.discount ?? 0) > 0 && (
          <>
            <StyledDivider />
            <PriceDetail
              label="סה״כ חיסכון ברכישה אונליין"
              price={-(price?.discount ?? 0)}
              finalDiscount
            />
          </>
        )}
        <StyledDivider />

        {/* {prepayment > 0 && ( */}
        <PriceDetail
          label="סה״כ מחיר מקדמה"
          price={advancePaymentAmount}
          finalDiscount
        />
        {/* )} */}

        {price && (
          <>
            <PriceDetail label={"סה״כ לתשלום"} price={price} final />

            {/* <StyledDivider /> */}
          </>
        )}

        {/* {!authenticated && <AuthenticateCTA />} */}
      </StyledContentContainer>
    </StyledPriceContainer>
  )
}

export default PriceDetails
